import { styled } from 'goober';

import { Button } from '@/ui/button/button';

export const SpotlightButton = styled(Button)`
  && {
    border-radius: 8px;
  }
`;
